import React, {Component} from "react";
import {Table} from "react-bootstrap";
import conversions from "../../../../services/API/components/Conversions";

class ConversionsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sortedBy: "",
            conversions: [...this.props.conversions]
        };

        this.sort = this.sort.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            conversions: nextProps.conversions
        })
    }

    sort (e) {
        const name = e.target.getAttribute("name");

        if(this.state.sortedBy === name) {
            return this.setState(prev => ({...prev, conversions: prev.conversions.reverse()}))
        }

        this.setState(prev => {
            let conversions = prev.conversions.sort((a, b) => {
                a = a[name];
                b = b[name];

                switch (name) {
                    case "date": return new Date(a) - new Date(b)
                    case "country": return a.localeCompare(b)
                    default: return a - b
                }
            });

            return {...prev, conversions, sortedBy: name};
        })
    }

    render() {
        return (
            <div>
                <Table bordered responsive>
                    <thead>
                    <tr>
                        <th className={"fitwidth"} name={"date"} onClick={this.sort.bind(this)}>Date</th>
                        <th className={"fitwidth"} name={"updated"} onClick={this.sort.bind(this)}>Updated</th>
                        <th name={"affid"} onClick={this.sort.bind(this)}>Affiliate ID</th>
                        <th name={"subid"} onClick={this.sort.bind(this)}>Subid</th>
                        <th name={"country"} onClick={this.sort.bind(this)}>Country</th>
                        <th name={"roi"} onClick={this.sort.bind(this)}>ROI</th>
                        <th name={"spend"} onClick={this.sort.bind(this)}>Spend</th>
                        <th name={"revenue"} onClick={this.sort.bind(this)}>Revenue</th>
                        <th name={"onwRevenue"} onClick={this.sort.bind(this)}>OnwRevenue</th>
                        <th name={"dailyOpt"} onClick={this.sort.bind(this)}>Daily Opt</th>
                        <th name={"cutoff"} onClick={this.sort.bind(this)}>Cutoff</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.conversions.map(({ id, date, updated, roi, spend, revenue, onwRevenue, affid, subid, country, dailyOpt, cutoff }) => {
                        return (
                            <tr key={id}>
                                <td className={"fitwidth"}>{date}</td>
                                <td className={"fitwidth"}>{updated}</td>
                                <td>{affid}</td>
                                <td>{subid}</td>
                                <td>{country}</td>
                                <td>{roi}</td>
                                <td>{spend}</td>
                                <td>{revenue || 0}</td>
                                <td>{onwRevenue || 0}</td>
                                <td>{dailyOpt || "0"}</td>
                                <td>{cutoff}</td>
                                <td className={"fitwidth"}>
                                    <button style={{ marginRight: '5px' }} className="btn btn-primary" onClick={() => this.props.onCutoffUpdate(id)}>Update Cutoff</button>
                                    <button className="btn btn-danger" onClick={() => this.props.onRemoveClick(id)}>Remove</button>
                                </td>
                            </tr>)
                    })}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default ConversionsTable;



// WEBPACK FOOTER //
// ./src/scenes/PeerclickConversionsCutoff/components/ConversionTable/index.js